import ApiClient from "@/libs/http-client";

const AdminService = {
  endpoints(route, params) {
    const url = {
      activePsychologists: `api/admin/psychologists/active?page=${params?.page}&admin_status_id=${params?.admin_status_id}&profile_tag_id=${params?.profile_tag_id}&search=${encodeURIComponent(params?.search || '')}`,
      inactivePsychologists: `api/admin/psychologists/inactive?page=${params?.page}&admin_status_id=${params?.admin_status_id}&profile_tag_id=${params?.profile_tag_id}&search=${encodeURIComponent(params?.search || '')}`,
      newPsychologists: `api/admin/psychologists/inactive?group=new&page=${params?.page}&admin_status_id=${params?.admin_status_id}&profile_tag_id=${params?.profile_tag_id}&search=${encodeURIComponent(params?.search || '')}`,
      deactivatedPsychologists: `api/admin/psychologists/inactive?group=deactivated&page=${params?.page}&admin_status_id=${params?.admin_status_id}&profile_tag_id=${params?.profile_tag_id}&search=${encodeURIComponent(params?.search || '')}`,
      archivedPsychologists: `api/admin/psychologists/inactive?group=archived&page=${params?.page}&admin_status_id=${params?.admin_status_id}&profile_tag_id=${params?.profile_tag_id}&search=${encodeURIComponent(params?.search || '')}`,
      archivePsychologist: `api/admin/psychologists/${params}/archive`,
      unarchivePsychologist: `api/admin/psychologists/${params}/unarchive`,
      activatePsychologist: `api/admin/psychologists/${params}/activate`,
      deactivatePsychologist: `api/admin/psychologists/${params}/deactivate`,
      psychologistPlacement: `api/admin/psychologists/${params}/placement`,
      unpaidPlacement: `api/admin/psychologists/placement/unpaid`,
      downloadPsychologistsInfo: `api/admin/psychologists/export`,
      updatePsychologistPhoto: `api/admin/psychologists/${params}`,
      deletePsychologist: `api/admin/psychologists/${params}`,
      editPsychologist: `api/admin/psychologists/${params}`,
    };
    return url[route];
  },

  get(url, params) {
    return ApiClient.get(this.endpoints(url, params));
  },
  post(url, params = {}, data, config = {}) {
    return ApiClient.post(this.endpoints(url, params), data, config);
  },
  patch(url, params = {}, data, config = {}) {
    return ApiClient.patch(this.endpoints(url, params), data, config);
  },
  delete(url, params = {}, data, config = {}) {
    return ApiClient.delete(this.endpoints(url, params), data, config);
  },
};

export default AdminService;
